/**
 * Resolve a media URL for browser display.
 *
 * Some publisher CDNs (e.g. LA Times Brightspot dims) hotlink-protect cross-site
 * <img> requests and redirect to a 1x1 placeholder unless the Referer is their
 * own domain. Those URLs usually wrap the real asset in a `url` query param
 * pointing at S3 (or another open host). Prefer that inner URL when present.
 */
export function resolveDisplayMediaUrl(url?: string | null): string {
  if (!url) return '';
  try {
    const parsed = new URL(url);
    if (!/\.brightspotcdn\.com$/i.test(parsed.hostname)) return url;
    const inner = parsed.searchParams.get('url');
    if (inner) {
      // Validate absolute URL before substituting.
      const unwrapped = new URL(inner);
      if (unwrapped.protocol === 'http:' || unwrapped.protocol === 'https:') {
        return unwrapped.toString();
      }
    }
  } catch {
    /* keep original */
  }
  return url;
}
